import styled from 'styled-components';

interface IItemElementProps {
  variation?: 'primary' | 'secondary';
}

export const ItemElement = styled.li<IItemElementProps>`
  margin: 0;
  cursor: pointer;
  display: grid;
  grid-template-columns: 25px 1fr;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1em;
  color: ${({ theme }) => theme.vars.newColor.black};
  font-size: 14px;
  text-transform: none;
  font-weight: 400;
  box-shadow: none;
  padding: 15px 20px;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: normal;
  text-decoration: none;
  background-color: ${({ variation }) => (variation === 'secondary' ? 'whitesmoke' : 'white')};

  &:hover,
  &:hover * {
    background-color: ${({ theme }) => theme.vars.color.pink};
    color: ${({ theme }) => theme.vars.newColor.white} !important;
  }

  &:focus {
    outline-offset: -4px;
  }
`;

export const IconElement = styled.span`
  display: inline-block;
  align-self: center;
  width: 25px;
  color: ${({ theme }) => theme.vars.newColor.black};
`;

export const LabelElement = styled.span`
  display: inline-block;
`;
